import React, { useEffect, useState } from 'react'
import {
    Container,
    CssBaseline,
    Avatar,
    Typography,
    TextField,
    Box,
    Button,
} from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import useStyles from 'pages/Auth/TwoFactorAuth/Styles'
import useActions from '../actions'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { AppRouteURI } from 'router/RoleBasedAccess'

const TwoFactorForm = () => {
    const classes = useStyles()
    const { email } = useSelector((state) => state.auth.two_factor_auth)
    const [isFormValid, setIsFormValid] = useState(true)
    const [otp, setOTP] = useState('')
    const [type, setType] = useState('totp')
    const { processOTP, renderVerificationMessage, sendEmailOTP } = useActions()

    const submitForm = (event) => {
        event.preventDefault()
        processOTP(email, otp, type)
        renderVerificationMessage(false)
    }

    useEffect(() => {
        if (type === 'email') {
            sendEmailOTP(email)
        }
    }, [type])

    return email === '' ? (
        <Redirect to={AppRouteURI.LOGIN} />
    ) : (
        <Container maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Two Factor Authentication -{' '}
                    {type === 'totp' ? 'Authenticator App' : 'Email based OTP'}
                </Typography>
                <form className={classes.form} onSubmit={submitForm} noValidate>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email"
                        name="email"
                        autoComplete="email"
                        disabled={true}
                        value={email}
                        autoFocus
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="otp"
                        label="One Time Password"
                        name="otp"
                        autoComplete="otp"
                        inputProps={{ min: 0, max: 999999, type: 'number' }}
                        value={otp}
                        onChange={(e) => setOTP(e.target.value)}
                        autoFocus
                    />
                    <Button
                        id="login-btn"
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        disabled={!isFormValid}
                    >
                        Login
                    </Button>
                    {type === 'email' && (
                        <Button
                            fullWidth
                            variant="outlined"
                            color="primary"
                            className={classes.submit}
                            onClick={() => sendEmailOTP()}
                        >
                            Resend OTP
                        </Button>
                    )}
                </form>
                <Box m={3}>
                    <Button
                        onClick={() =>
                            setType(type === 'totp' ? 'email' : 'totp')
                        }
                        variant="outlined"
                    >
                        Authenticate with{' '}
                        {type === 'totp'
                            ? 'Email based OTP'
                            : 'Authenticator App'}
                    </Button>
                </Box>
            </div>
        </Container>
    )
}

export default TwoFactorForm
